import OneWay from "./OneWay";

export default OneWay;
